import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/whyChooseUsImg.png";
import "./styles.scss";
import ServiceIcon from "../components/services/serviceIcons";
import { ReactComponent as ExperienceIcon } from "../assets/icons/our-experience.svg";
import { ReactComponent as QualityIcon } from "../assets/icons/quality-of-code.svg";
import { ReactComponent as AttitudeIcon } from "../assets/icons/our-attitude.svg";
import { ReactComponent as CheckIcon } from "../assets/icons/check.svg";
import './chooseUsPage.scss';

const whyChooseUs = require('../assets/images/why-choose-us.png');

const progressData = [
  { label: 'Custom Software Development', percentage: 89 },
  { label: 'Technology Management', percentage: 95 },
  { label: 'Corporate Management', percentage: 87 },
  { label: 'Consultancy', percentage: 90 },
];

const ChooseUsPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground insideText={"Our Mission"} imgPath={BackgroundImg} />
      <div className="why-choose-us-section">
        <div className="text-section">
          <div className="item">
            <span className="title">Our Mission</span>
            <span className="description">At Cube Global, our mission is to empower businesses with innovative, custom-built software solutions that drive growth and success in the digital era. We are committed to delivering exceptional value through cutting-edge technology, strategic consulting, and unparalleled expertise. By continuously pushing the boundaries of what’s possible, we help our clients stay competitive, streamline their operations, and achieve their long-term goals.</span>
          </div>
          <div className="item">
            <span className="title">Our Perspective</span>
            <span className="description">At Cube Global, delivering solutions is more than just work—it's our passion. We take pride in fostering a culture of excellence, where every team member strives for the highest standards in all that we do. Our commitment to quality and professionalism is reflected in every project, and we don't rest until we’ve achieved exceptional results.
            </span>
          </div>
          <div className="item">
            <span className="title">Our Unique Expertise</span>
            <span className="description">
              Cube Global leverages its cutting-edge DC-COM Rapid Application Development framework, enabling us to rapidly prototype and develop sophisticated web-based applications. This framework is equipped with a comprehensive suite of components, allowing for seamless integration of new features into your application or website. Our continuously evolving, world-class content management system (CMS) ensures your business remains agile and adaptable to changing market demands, helping you stay ahead in today’s fast-paced digital landscape.
            </span>
          </div>
          <div className="item">
            <span className="title">Management Solution</span>
            <span className="description">Our proprietary management solutions set us apart from competitors. No other web development company offers the unique suite of components and CMS solutions we provide, and many development firms rely on our technology for their projects. Our expertise spans ColdFusion Application Development, database design, server configuration, and advanced graphic design. At Cube Global, we don’t just build software—we create scalable, innovative solutions that drive business success in today’s ever-evolving tech landscape.</span>
          </div>
        </div>
        <div className="image-container">
          <img src={whyChooseUs} />
        </div>
      </div>
      <div className="our-benefits-section">
        <span className="title">Our Values</span>
        <div className="services-content-list">
          <ServiceIcon
            title={"Our experience"}
            content={
              "With over 200 successfully completed projects, Cube Global has delivered a wide range of solutions, including data-driven websites, e-commerce platforms, intranets, extranets, content management systems, CRM systems, and other custom database-driven applications. Our diverse experience across various industries enables us to create innovative, high-quality solutions tailored to meet the evolving needs of our clients."
            }
            icon={ExperienceIcon}
          />
          <ServiceIcon
            title={"Commitment to Code Quality"}
            content={
              "At Cube Global, quality is our top priority. Every line of code undergoes rigorous peer review, ensuring it meets the highest industry standards. We use automated code review tools to ensure that our ColdFusion projects adhere to best practices, maintaining efficiency, security, and scalability. Our commitment to clean, high-performance code sets us apart in the development industry."
            }
            icon={QualityIcon}
          />
          <ServiceIcon
            title={"Our Approach"}
            content={
              "We pride ourselves on being a team of approachable, down-to-earth professionals focused on building long-term partnerships. Our goal is to create lasting value for our clients through exceptional service and cutting-edge solutions."
            }
            icon={AttitudeIcon}
          />
        </div>
      </div>
      <div className="separator"></div>
      <div className="quality-section">
        <div className="list">
          <div className="item">
            <div className="title-container">
              <span className="title">Quality Assurance</span>
              <CheckIcon />
            </div>
            <span className="description">
              At Cube Global, quality is a fundamental principle embedded in every aspect of our work. Each project, regardless of its size, is overseen by a dedicated quality controller who rigorously reviews all elements to ensure they meet the highest standards and project specifications.
              <br /><br />
              Our collaborative approach involves regular peer reviews among developers and designers to continuously refine the quality of our work. By incorporating the latest industry standards—such as HTML5, CSS3, advanced database methodologies, and responsive web design—we ensure that every solution is built on a strong, modern foundation.
            </span>
          </div>
          <div className="item">
            <div className="title-container">
              <span className="title">Content Management Solution</span>
              <CheckIcon />
            </div>
            <span className="description">
              With our custom-built content management system, we maintain full control over its development and functionality. Having successfully managed over 200 websites on this platform, it has consistently evolved to meet the dynamic needs of our clients. By choosing Cube Global, you gain access to an enterprise-level CMS that offers both flexibility and control, empowering businesses to manage their digital presence with ease and precision.
            </span>
          </div>
        </div>
        <div className="list">
          <div className="item">
            <div className="title-container">
              <span className="title">Quality of Database Design</span>
              <CheckIcon />
            </div>
            <span className="description">
              Proper database design is critical for a project’s success. At Cube Global, we excel in developing robust, scalable databases that ensure data integrity and optimal performance. 
              <br /><br />
              We follow best practices in table and field naming, enforce foreign key constraints, and implement indexing for quick data retrieval. Our structured approach guarantees that your database is built to grow and evolve with your business.
            </span>
          </div>
          <div className="item">
            <div className="title-container">
              <span className="title">Ongoing Support</span>
              <CheckIcon />
            </div>
            <span className="description">
              At Cube Global, our focus extends far beyond delivering a product. We forge long-term, strategic partnerships. Our unwavering commitment to your success continues well beyond launch, providing ongoing support, expert guidance, and tailored solutions to ensure your website or application maintains peak performance and competitiveness. Our objective is to be a trusted partner, delivering the expertise and insight needed to drive your business forward and navigate evolving challenges.
            </span>
          </div>
        </div>

      </div>
      <div className="progress-bars-container">
        {progressData.map((item, index) => (
          <div key={index} className="progress-bar-item">
            <div className="text-container">
              <span className="label">{item.label}</span>
              <span className="percentage">{item.percentage}%</span>
            </div>
            <div className="progress">
              <div
                className="progress-fill"
                style={{ width: `${item.percentage}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>

  );
};

export default ChooseUsPage;
